import { State } from 'store/state';
import { connect } from 'react-redux';
import ILSchoolsWidget from 'components/widget/heb-schools/il-schools-widget';
import {
  hoveredSchoolIdSelector,
} from 'store/state/insightsContext/selectors';
import {
  setHoveredSchoolId,
} from 'store/state/insightsContext/actions';
import { ilSchoolsDataSelector } from 'store/state/selectors/insights/schools';
import { isCollapsedInsightsSelector } from 'store/state/selectors/insights/insightSections';


const mapStateToProps = (state: State) => ({
  data: ilSchoolsDataSelector(state),
  hoveredSchoolId: hoveredSchoolIdSelector(state),
  isCollapsed: isCollapsedInsightsSelector(state),
});

const mapDispatchToProps = {
  setHoveredSchoolId,
};

export default connect(mapStateToProps, mapDispatchToProps)(ILSchoolsWidget);
